import { CakeBoxIcon } from '~/components/icon/cake-box'

export function BubbleReminder(props: { count: number; onClick: () => void }) {
  // The wrapper handles positioning + the bounce-in animation (transform on
  // the wrapper). Keeping the button transform-free preserves its own
  // `active:scale-95` tap feedback independently.
  return (
    <div class="absolute left-3 top-[60%] z-40 origin-left animate-bubble-in">
      <button
        type="button"
        onClick={props.onClick}
        class="relative inline-flex items-center justify-center gap-[2px] rounded-[17px] px-2.5 py-2.5 text-bakery-brown backdrop-blur-[20px] transition-transform [box-shadow:0_11px_7.15px_rgba(0,0,0,0.13)] [transition-duration:150ms] active:scale-95"
      >
        <span
          aria-hidden
          class="pointer-events-none absolute -left-[12px] top-[12px] block h-[14px] w-[14px] backdrop-blur-[20px]"
          style={{ 'clip-path': 'polygon(100% 0%, 100% 100%, 0% 50%)' }}
        />

        <span
          aria-hidden
          class="pointer-events-none absolute inset-0 opacity-[0.73]"
        >
          <span class="absolute inset-0 rounded-[17px] bg-[#FFCD29]" />
          <span
            class="absolute -left-[12px] top-[12px] block h-[14px] w-[14px] bg-[#FFCD29]"
            style={{ 'clip-path': 'polygon(100% 0%, 100% 100%, 0% 50%)' }}
          />
        </span>

        <span class="relative inline-flex items-center gap-[2px]">
          <CakeBoxIcon class="block size-6" />
          <span class="text-[16.3px] font-bold tabular-nums leading-[23.3px] text-bakery-brown">
            {props.count}
          </span>
        </span>
      </button>
    </div>
  )
}
